"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mappingMetaOptions = exports.newMetaOptions = void 0;
const firebaseconfig_1 = require("@upflowy/firebaseconfig");
const primaryFont = 'https://fonts.googleapis.com/css2?family=Roboto:wght@400&display=swap';
const secondaryFont = 'https://fonts.googleapis.com/css2?family=Roboto:wght@400&display=swap';
exports.newMetaOptions = {
    'light-primary-button-border-color': '#ffffff',
    'light-primary-button-border-color-hover': '#ffffff',
    'light-progress-bar-border-color': '#555',
    'light-secondary-button-border-color': '#ffffff',
    'light-secondary-button-border-color-hover': '#ffffff',
    'field-font-weight': 'regular',
    'dark-h2-color': '#000000',
    'light-back-close-button-color': '#aaa',
    'light-text-color': '#000000',
    'description-font-style': 'normal',
    'dark-h1-color': '#000000',
    'light-h1-color': '#000000',
    'answer-font-family': 'var(--primary-font-family)',
    'text-font-size': '12px',
    'dark-primary-button-background-color': '#000000',
    'dark-primary-button-background-color-hover': '#242424',
    'light-field-border-color': '#aaa',
    'field-font-style': 'normal',
    'answer-font-style': 'normal',
    'button-font-style': 'normal',
    'light-label-font-color': '#000000',
    'field-font-family': 'var(--primary-font-family)',
    'error-font-family': 'var(--primary-font-family)',
    'dark-question-font-color': '#000000',
    'field-placeholder-font-weight': 'regular',
    'dark-description-font-color': '#000000',
    'question-font-weight': 'regular',
    'light-primary-button-font-color': '#ffffff',
    'light-primary-button-font-color-hover': '#ffffff',
    'dark-field-selected-options-color': '#aaa',
    'light-dismiss-button-background-color': '#000000',
    'label-font-size': '12px',
    'light-progress-bar-complete-color': '#aaa',
    'h1-font-size': '40px',
    'button-font-family': 'var(--primary-font-family)',
    'light-disabled-button-border-color': '#e3e3e3',
    'text-font-family': 'var(--primary-font-family)',
    'answer-font-weight': 'regular',
    'h2-font-family': 'var(--primary-font-family)',
    'dark-progress-bar-complete-color': '#aaa',
    'light-disabled-button-font-color': '#ffffff',
    'error-font-size': '8px',
    'light-field-selected-options-color': '#aaa',
    'light-question-font-color': '#000000',
    'dark-secondary-button-font-color': '#ffffff',
    'dark-secondary-button-font-colo-hover': '#ffffff',
    'dark-background-color': '#F0DADA',
    'dark-field-background-color': '#ced4da',
    'dark-secondary-button-border-color': '#ffffff',
    'dark-secondary-button-border-color-hover': '#ffffff',
    'h1-font-style': 'normal',
    'light-secondary-button-font-color': '#ffffff',
    'light-secondary-button-font-color-hover': '#ffffff',
    'description-font-family': 'var(--primary-font-family)',
    'dark-placeholder-font-color': '#c3c3c3',
    'light-link-color': '#555',
    font: primaryFont,
    'primary-font-family': 'Roboto',
    'primary-font-source': 'google',
    'field-placeholder-font-style': 'normal',
    'dark-dismiss-button-background-color': '#000000',
    'button-border-style': 'solid',
    'label-font-family': 'var(--primary-font-family)',
    'dark-primary-button-font-color': '#ffffff',
    'dark-primary-button-font-color-hover': '#ffffff',
    'field-placeholder-font-size': '12px',
    'question-font-family': 'var(--primary-font-family)',
    'text-font-style': 'normal',
    'dark-primary-button-border-color': '#ffffff',
    'dark-primary-button-border-color-hover': '#ffffff',
    'light-field-font-color': '#000000',
    'light-primary-button-background-color': '#000000',
    'light-primary-button-background-color-hover': '#242424',
    'dark-progress-bar-remaining-color': '#fff',
    'dark-label-font-color': '#000000',
    'dark-back-button-background-color': '#000000',
    'error-font-style': 'normal',
    'field-font-size': '12px',
    'dark-disabled-button-background-color': '#e3e3e3',
    'label-font-weight': 'regular',
    'dark-disabled-button-font-color': '#ffffff',
    'light-description-font-color': '#000000',
    'field-border-style': 'solid',
    'button-font-size': '12px',
    'h1-font-weight': 'regular',
    'question-font-style': 'normal',
    'field-border-width': '2px',
    'field-border-radius': '5px',
    'h1-font-family': 'var(--primary-font-family)',
    'light-background-color': '#FFFFFF',
    'secondary-font-family': 'Roboto',
    'secondary-font-source': 'google',
    secondaryFont,
    'label-font-style': 'normal',
    'field-placeholder-font-family': 'var(--primary-font-family)',
    'dark-field-border-color': '#aaa',
    'error-font-weight': 'regular',
    'light-progress-bar-remaining-color': '#fff',
    'button-font-weight': 'regular',
    'dark-back-close-button-color': '#aaa',
    'h2-font-style': 'normal',
    'button-border-radius': '5px',
    'description-font-size': '12px',
    'light-error-message-color': '#ff0000',
    'text-font-weight': 'regular',
    'dark-disabled-button-border-color': '#e3e3e3',
    'h2-font-weight': 'regular',
    'light-h2-color': '#000000',
    'logo-padding': '5px',
    'dark-link-color': '#ddd',
    'dark-progress-bar-border-color': '#555',
    'question-font-size': '12px',
    'dark-field-font-color': '#000000',
    'dark-text-color': '#000000',
    'light-disabled-button-background-color': '#e3e3e3',
    'light-field-background-color': '#ced4da',
    'description-font-weight': 'regular',
    'button-border-width': '2px',
    'light-back-button-background-color': '#000000',
    'light-placeholder-font-color': '#c3c3c3',
    'dark-secondary-button-background-color': '#000000',
    'dark-secondary-button-background-color-hover': '#242424',
    'dark-error-message-color': '#ff0000',
    'h2-font-size': '32px',
    'light-secondary-button-background-color': '#000000',
    'light-secondary-button-background-color-hover': '#242424',
    'answer-font-size': '12px',
    'light-logo': `${firebaseconfig_1.appBaseURLs.cdnPath}/public%2Fassets%2Fupflowy-logo.png`,
    'dark-logo': `${firebaseconfig_1.appBaseURLs.cdnPath}/public%2Fassets%2Flogo-white.png`,
};
exports.mappingMetaOptions = {
    fieldMap: {
        'question-font-size': 'label-font-size',
        'question-font-weight': 'label-font-weight',
        'question-font-style': 'label-font-size',
        'description-font-size': 'label-font-size',
        'description-font-weight': 'label-font-weight',
        'description-font-style': 'label-font-size',
        'answer-font-size': 'label-font-size',
        'answer-font-weight': 'label-font-weight',
        'answer-font-style': 'label-font-size',
        'light-question-font-color': 'light-label-font-color',
        'light-description-font-color': 'light-label-font-color',
        'dark-question-font-color': 'dark-label-font-color',
        'dark-description-font-color': 'dark-label-font-color',
    },
    oldFontUnit: 'rem',
    newFontUnit: 'px',
    changeUnit: (n) => n * 16,
};
//# sourceMappingURL=meta-options-migration.js.map